<template>
  <div class="row">
    <!--Navmenu starts here-->
    <div
      class="sidebar"
      :class="{'col-2': sidebar, 'col-1': !sidebar}"
      @mouseover="sidebar = true"
      @mouseout="sidebar=menuclicked"
    >
      <!--Logo image starts-->
      <img
        :class="{active: !sidebar}"
        id="mainlogo"
        class="logo-image"
        src="../assets/icons/Sidemenu/logo.svg"
      />
      <img
        :class="{active: sidebar}"
        class="logo-image"
        src="../assets/icons/Sidemenu/minilogo.svg"
      />
      <!--Logo image ends-->
      <!--List of options starts-->
      <div class="options-wrapper">
        <!--Each option button starts here-->
        <div
          class="option-wrapper"
          v-for="(option, index) in availableMenuItem"
          :key="index"
          :class="{'selected-option': activeOption==option.open}"
          @click="setSelected(index)"
        >
          <!--option image on the left side of option-->
          <img :src="getImageUrl(option.image)" />
          <!--option name-->
          <span class="option" :class="{active: !sidebar, normal: menuclicked}">
            <span class="section">{{option.label}}</span>
          </span>
          <!--if option have sub categories, an arrow icon and the corresponding categories-->
          <img
            v-if="option.options!=null"
            class="arrow-icon"
            :class="{'open' : activeOption==option.open}"
            src="../assets/icons/Sidemenu/arrow.svg"
          />
          <div
            class="option-list"
            :class="{ 'open-options' : activeOption==option.open, active: !sidebar }"
          >
            <div
              class="category"
              v-for="(category, num) in option.options"
              :key="num"
              @click.stop="setCategory($event, category)"
            >
              <img src="../assets/icons/Sidemenu/line.svg" />
              <span class="category-name">{{category}}</span>
            </div>
          </div>
        </div>
        <!--option button ends here-->
      </div>
      <!--List of options ends-->
    </div>
    <!--Navmenu ends here-->

    <!--content starts here (All of the components others than sidemenu)-->
    <div class="content-wrapper">
      <!--Change here to affect topbar-->
      <div class="topbar col-12">
        <button class="menu-icon" @click="changeNavSize">
          <img src="../assets/icons/Sidemenu/hamburger.svg" />
        </button>
        <!-- <button class="search-icon">
          <img src="../assets/icons/Sidemenu/search.svg" />
        </button>-->
        <div @click="openlogout=!openlogout" style="curser:pointer">
          <div class="user-name">{{firstName}} {{lastName}}</div>
          <div class="usr-button"></div>
        </div>
        <button
          class="logout-popup"
          v-if="openlogout"
          v-on-clickaway="()=>openlogout=false"
          @click="logout()"
        >Logout</button>
      </div>
      <!--topbar ends-->
      <!--content with context (route-view and view path)-->
      <div class="content">
        <!--Path to the present view-->
        <div v-if="openView" class="view-label">
          <span class="view-heading">{{openView}}</span>
          <div class="path-label-wrapper" v-for="(label, index) in openCategory" :key="index">
            <span
              v-if="openCategory.length"
              class="category-label"
              :class="{'active': label.focus}"
            >{{label.name}}</span>
            <img v-if="index < openCategory.length-1" src="../assets/icons/landingpage/home.svg" />
          </div>
        </div>
        <!--Path to the present view ends-->
        <!-- remove the midSection div in new design -->
        <div class="m-4 midSection">
          <router-view class="route-view" :maximized="!sidebar"></router-view>
        </div>
        <!-- remove the midSection div in new design -->
      </div>
      <!--content ends here-->
    </div>
    <!--content ends here-->

    <div class="snackbar">
      <sweet-modal
        ref="modal"
        icon="warning"
        id="alert"
        style="background: rgba(0, 0, 0, 0.15);"
      >{{this.snackbarMsg}}</sweet-modal>
    </div>
    <Loader />
  </div>
</template>

<script>
import { directive as onClickaway } from "vue-clickaway";
import { Component, Vue } from "vue-property-decorator";
import Loader from "@/components/loader.vue";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";

export default {
  name: "navList",
  components: {
    Loader,
    SweetModal,
    SweetModalTab
  },

  directives: {
    onClickaway: onClickaway
  },
  data() {
    return {
      sidebar: true,
      menuclicked: true,
      //options data should be retrieved from backend
      options: [
        // {
        //   label: "Analytics",
        //   image: "analytics.svg",
        //   link: "",
        //   open: "analytics",
        //   users: ["manager", "supervisor"]
        // },
        {
          label: "Config Group",
          image: "configgrp.svg",
          link: "/app/secure/group/all",
          open: "groupcenter",
          users: ["admin"]
        },
        {
          label: "Inspection Summary",
          image: "summary.svg",
          link: "/app/secure/inspectionSummary/summary",
          open: "inspectionSummary",
          users: ["supervisor", "manager", "inspector"]
        },
        {
          label: "Commodities",
          image: "commodities.svg",
          link: "/app/secure/inspectionTemplate",
          open: "inspectionTemplate",
          /*options: [
                        //'All commodities',
                        //'Add / Remove',
                    ],*/
          categories: true,
          users: ["supervisor", "inspector"]
        },
        {
          label: "Config User",
          image: "configusr.svg", //link here
          link: "/app/secure/admincenter",
          open: "admincenter",
          users: ["admin"]
        },
        {
          label: "Autonomous Inspection",
          image: "VisualRecognition.svg",
          link: "/app/secure/visualrecognition",
          open: "visualrecognition",
          users: []
        },
        // {
        //   label: "Image Analysis",
        //   image: "VisualRecognition.svg",
        //   link: "/app/secure/bi",
        //   open: "bi",
        //   users: ["supervisor", "manager",]
        // },
      ],
      openoptions: false,
      userInitials: "",
      user: "",
      openlogout: false
    };
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
    role() {
      return this.$store.state.user;
    },
    firstName() {
      return this.$store.state.firstName;
    },
    lastName() {
      return this.$store.state.lastName;
    },
    availableMenuItem() {
      var displayedItems = this.options.filter(obj => {
        return obj.users.includes(this.role);
      });
      return displayedItems;
    },
    openCategory() {
      var open = this.$store.state.path.categories;
      return open;
    },
    openView() {
      var open = this.$store.state.path.view;
      return open;
    },
    snackbarMsg() {
      return this.$store.state.snackbarMsg;
    },
    activeOption() {
      return this.$route.matched[1].name;
    }
  },
  watch: {
    snackbar: function(val) {
      if (val) {
        this.$refs.modal.open();
      }
    }
  },
  methods: {
    /*
            image links in a loop won't be compiled so they won't work.
            So we are asserting them so that webpack will compile it before runtime
        */
    getImageUrl(url) {
      return require("../assets/icons/Sidemenu/" + url);
    },
    //Minimizes and maximizes menu
    changeNavSize() {
      this.menuclicked = !this.menuclicked;
      this.sidebar = !this.sidebar;
    },
    //sets path view data for option and adds/clears class="active" to/from selected options
    setSelected(index) {
      this.$router.push(this.availableMenuItem[index].link);
    },
    //Sets path view with the data recorded from above two methods
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  },
  mounted() {
    this.user = this.$store.state.user;
    //sets user initials in the top right
    this.userInitials = this.$store.state.username
      .substring(0, 2)
      .toUpperCase();
  },
  beforeCreate() {
    this.$store.dispatch("showLoader", true);
  }
};
</script>

<style scoped>
/* NOTE: IF POSSIBLE MINIMIZE THE RULES BY GROUPING THE RULES COMMON TO MANY OF THE ELEMENTS */
.row {
  display: flex;
  overflow-y: hidden;
}

.midSection {
  margin-top: 0px !important;
  height: calc(100% - 124px);
  box-sizing: border-box;
  overflow: hidden auto;
}

.sidebar {
  padding: 0px;
  background: #343434;
  color: white;
  height: 100vh;
  transition: 0.5s;
  position: sticky;
  top: 0px;
  overflow-x: hidden;
}

.option-list {
  position: relative;
  right: 30px;
  width: inherit;
  margin-top: 20px;
  max-height: 0px;
  overflow: hidden;
  background: #343434;
  transition: max-height 0.3s ease-in-out, opacity 0.3s;
}

.open-options {
  max-height: 1000px;
}

.category {
  margin-left: 40px;
  padding-top: 10px;
  padding-bottom: 20px;
  color: #c3e6ce;
  border-left: 1px solid rgba(195, 230, 206, 0.5);
}

.category:hover {
  color: #fff;
}

.option {
  transition: opacity 0.5s;
  margin: 10px;
  margin-left: 30px;
}

.option.normal {
  transition: 0s;
}

.option-wrapper {
  padding-left: 30px;
  padding-top: 15px;
  min-height: 40px;
  height: auto;
  width: inherit;
  transition: background-color 0.2s;
  color: #c3e6ce;
  cursor: pointer;
}

.option-wrapper > img {
  width: 20px;
}

.option-wrapper:hover {
  background: #616562;
  color: #fff;
}

.option-wrapper:hover > img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(71%) saturate(2%)
    hue-rotate(307deg) brightness(105%) contrast(101%);
}

.logo-image {
  position: fixed;
  top: 17px;
  left: 10px;
  transition: 0.5s;
}

#mainlogo {
  top: 15px;
  left: 20px;
}

.options-wrapper {
  position: fixed;
  margin-top: 70px;
  width: inherit;
}

.content-wrapper {
  position: relative;
  display: flex;
  flex: 1;
  z-index: 2;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #f2f2f2;
}

.arrow-icon {
  width: 5px;
  height: 10px;
  margin-left: 40px;
  transition: transform 0.3s;
}

.open {
  transform: rotate(90deg);
}

.option-list.active {
  max-height: 0px;
}

.selected-option {
  background: #616562;
  color: white;
}

.selected-option > img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(71%) saturate(2%)
    hue-rotate(307deg) brightness(105%) contrast(101%);
}

.topbar {
  height: 58px;
  box-shadow: 0px 1px 24px rgba(0, 0, 0, 0.15);
  z-index: 11;
  position: sticky;
  top: 0px;
  background: #fff;
}

.content {
  position: absolute;
  height: calc(100vh - 58px);
  margin-top: 58px;
  background: #f2f2f2;
  width: 100%;
}

.col-1 {
  max-width: 70px !important;
  min-width: 70px !important;
}

.col-2 {
  min-width: 240px !important;
  max-width: 240px !important;
}

.active {
  opacity: 0;
}

.menu-icon {
  margin-top: 17px;
  margin-left: 20px;
}

.search-icon {
  position: absolute;
  right: 115px;
  top: 30%;
}
.user-name {
  position: absolute;
  cursor: pointer;
  right: 85px;
  font-size: 1.25rem;
  top: 30%;

  height: 40px;
}
.usr-button {
  position: absolute;
  right: 35px;
  top: 15%;
  height: 40px;
  width: 40px;
  border-radius: 20px;
  cursor: pointer;
  background-image: url("../assets/icons/UserImage.svg");
}

.logout-popup {
  position: absolute;
  right: 38px;
  top: calc(15% + 43px);
  background: #24c656;
  color: white;
  height: 40px;
  width: 60px;
}

.section {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;

  color: inherit;
}

button:focus {
  outline: none;
}

.view-label {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;

  color: #29342e;
  padding: 32px 0px 20px 32px;
}

.route-view {
  height: max-content;
}

.view-heading {
  border-right: 1px solid #c4c4c4;
  padding-right: 20px;
  margin-right: 20px;
}

.category-label {
  padding: 0px 10px 0px 10px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #29342e;
}

.category-label.active {
  font-weight: 600;
  color: black;
  opacity: 1;
}

.category-name {
  margin-left: 25px;
}

.path-label-wrapper {
  display: inline-block;
}
</style>

<style>
body *{
  scrollbar-width: thin !important;
 
  /* chrome */
  
}
 
/* width */
body *::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
 
/* Track */
body *::-webkit-scrollbar-track {
  background: #F6F6F7; 
}
 
/* Handle */
body *::-webkit-scrollbar-thumb {
  background: #888; 
}
 
/* Handle on hover */
body *::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.sweet-modal {
  border-radius: 4px;
  width: 371px;
  left: 54%;
}

.sweet-modal-icon.sweet-modal-warning .sweet-modal-body {
  height: 22px;
}

.sweet-modal-icon {
  width: 55px;
  height: 55px;
}

.sweet-modal .sweet-content .sweet-modal-icon {
  margin-bottom: 13px;
}

.sweet-modal.is-alert .sweet-content {
  padding-top: 20px;
  padding-bottom: 20px;
}

.sweet-modal .sweet-box-actions .sweet-action-close:hover {
  background: #24c656;
  color: #fff;
}

.sweet-modal .sweet-box-actions .sweet-action-close {
  color: #24c656;
}

.ui.dropdown:not(.button) > .default.text[data-v-4030daa2],
.ui.default.dropdown:not(.button) > .text {
  color: #29342e;
}
</style>
